<template>
  <div class="" id="magic-canvas-outer-container">
    <div v-show="activeStage.preview === true"  v-bind:class="{'loading-image-breathing loading-image-greyscale': currentJob.state === 'processing'}">
      <canvas id="magic-canvas-preview"></canvas>
    </div>
    <div v-show="activeStage.preview === false">
      <canvas id="magic-canvas" ></canvas>
    </div>
    <div id="magic-canvas-export-container">
    <canvas id="magic-canvas-export" ></canvas>
    </div>
  </div>
</template>
<script>
import currentJob from "../../mixins/current_job.mixin";
import store from "../../mixins/store.mixin";
import UploadBox from "../Elements/UploadBox.vue";
import CanvasManager from "../../manager/CanvasManager";
import {EventBus} from "../../events/event.bus";

export default {
  name: "MagicCanvas",
  props: {},
  components: {UploadBox},
  mixins: [
    currentJob,
    store
  ],
  data() {
    return {};
  },
  mounted: function () {
    CanvasManager.init(this.currentJob.getActiveStageJob());
  },
  created: function () {
  },
  methods: {},
  computed: {}
};
</script>
<style lang="scss">
#magic-canvas-outer-container {
  overflow: auto;
  flex: 1 1 auto;
}
#magic-canvas
{
  width: 100%;
  height: 100%;
}
#magic-canvas-export-container {
  display: none;
  position:absolute;
  top: -10000px;
  left: -10000px;
}

.loading-image-greyscale {
}

.loading-image-breathing {
  animation: breathing 5s ease-out infinite normal, greyscale-fade-out 3s ease-in forwards;
}

@-webkit-keyframes breathing {
  0% {
    -webkit-transform: scale(0.97);
    transform: scale(0.97);
  }

  25% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }

  60% {
    -webkit-transform: scale(0.97);
    transform: scale(0.97);
  }

  100% {
    -webkit-transform: scale(0.97);
    transform: scale(0.97);
  }
}

@keyframes breathing {
  0% {
    -webkit-transform: scale(0.97);
    -ms-transform: scale(0.97);
    transform: scale(0.97);
  }

  25% {
    -webkit-transform: scale(1);
    -ms-transform: scale(1);
    transform: scale(1);
  }

  60% {
    -webkit-transform: scale(0.97);
    -ms-transform: scale(0.97);
    transform: scale(0.97);
  }

  100% {
    -webkit-transform: scale(0.97);
    -ms-transform: scale(0.97);
    transform: scale(0.97);
  }
}


@keyframes greyscale-fade-out {
  0%   { -webkit-filter: grayscale(0%); }
  100% { -webkit-filter: grayscale(100%); }
}

</style>
